module.exports = __webpack_public_path__ + "img/index-new-02.ecd833ee.svg";